export const HourMs = 60 * 60 * 1000;
export const DayMs = 24 * HourMs;

export const SupportDateRangePresets = [
  { id: "2h", label: "Last two hours", ms: 2 * HourMs },
  { id: "6h", label: "Last 6hs", ms: 6 * HourMs },
  { id: "1d", label: "Last day", ms: DayMs },
  { id: "1w", label: "Last week", ms: 7 * DayMs },
  { id: "1m", label: "Last month", ms: 30 * DayMs },
] as const;

export type SupportDateRangePresetId =
  (typeof SupportDateRangePresets)[number]["id"];

export function rangeForSupportDatePreset(
  presetId: SupportDateRangePresetId,
  now = new Date()
): { from: Date; to: Date } {
  const preset = SupportDateRangePresets.find((p) => p.id === presetId);
  if (!preset) {
    return { from: new Date(now.getTime() - DayMs), to: now };
  }
  return {
    from: new Date(now.getTime() - preset.ms),
    to: now,
  };
}
